export const LOGIN_CONSTANTS = {
  HERO_TEXT:
    "Accumulate HYP coins through rewarding experiences and gain entry to exclusive brand loyalty programs. Earn valuable perks while enjoying unique privileges – sign up today to elevate your rewards game!",
  RESPONSIVE_HERO_MESSAGE:
    "Earn HYP coins on rewards and get access to exclusive brand loyalty programs.",
  SIGN_IN_TITLE: "Sign in",
  SIGN_IN_UID_PIN_SUBTITLE: "Enter Your UID & PIN",
  SIGN_IN_EMAIL_SUBTITLE: "Enter Your Email",
  SIGN_IN_OTP_SUBTITLE_EMAIL: "Enter OTP Sent To Your Registered Email",
  SIGN_IN_OTP_SUBTITLE_MOBILE: "Enter OTP Sent To Your Registered Mobile No",
  SIGN_IN_MOBILE_SUBTITLE: "Enter Your Mobile No.",
  UID_TYPE: "U",
  MOBILE_TYPE: "M",
  EMAIL_TYPE: "E",
  UID_LABEL: "UID",
  PIN_LABEL: "PIN",
  UID_PLACEHOLDER: "Enter your UID",
  PIN_PLACEHOLDER: "Enter your PIN",
  EMAIL_PLACEHOLDER: "Enter your Email",
  MOBILE_PLACEHOLDER: "Enter your Mobile No.",
  TERMS_TEXT: "By clicking the above button, you agree to our",
  TERMS_LINK: "Terms & Conditions",
  CONTACT_EMAIL: "support@hyp.com",
  CONTACT_PHONE: "+91 9998899988",
  BACK_TO_SIGN_IN: "Back to sign in",
};
